/* Safari */
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) { 
  document.body.classList.add('is-safari');
}


/* Header */
  if(document.querySelector('.homepage-transparent-header') != null) {
    
    if(document.querySelector('header-menu>details') != null) {
      document.querySelectorAll('header-menu>details>summary').forEach(function(item){
        item.addEventListener('click', function() {
            
          if (item.closest('.mega-menu').hasAttribute('open')) {
              item.closest('.header-wrapper').classList.remove('open-megamenu');
          } else {
              item.closest('.header-wrapper').classList.add('open-megamenu');
          }
        });
      });
    }
  }
  
  document.querySelector('.menu-drawer__inner-close-icon').addEventListener('click', function() {
    this.closest('.menu-opening').querySelector('summary').click();
  });
/* End Header */

/* Product Thumbnail */
class VerticalSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollTop - offset;
    return element.offsetTop + element.clientWidth <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      top: position,
    });
  }
}

customElements.define('vertical-slider-component', VerticalSliderComponent);


class Footer extends HTMLElement {
  constructor() {
    super();
    this.accordionTrigger = '[data-accordion-trigger]';
    this.mobileBreakpoint = 749;
    this.triggerClickHandlers = new Map();
    this.initMobileCollapsibles();
    this.setupBreakpointListener();



    const accordion_items = this.querySelectorAll('.footer-accordion');
    if (accordion_items.length) {
      accordion_items[accordion_items.length - 1].classList.add('last-accordion');
    }
  }

  initMobileCollapsibles() {
    const mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`);
    if (mediaQuery.matches) {
      this.activateMobileCollapsibles();
    }
  }

  setupBreakpointListener() {
    const mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`);
    mediaQuery.addEventListener('change', (e) => {
      if (e.matches) {
        this.activateMobileCollapsibles();
      } else {
        this.deactivateMobileCollapsibles();
      }
    });
  }

  activateMobileCollapsibles() {
    const accordionElements = this.querySelectorAll('.footer-accordion');
    
    accordionElements.forEach((element) => {
      if (!element.hasAttribute('data-collapsible-active')) {
        element.setAttribute('data-collapsible-active', 'true');
        
        const trigger = element.querySelector(this.accordionTrigger);
        if (trigger) {
          const handler = (event) => {
            event.preventDefault();
            element.classList.toggle('is-open');
          };
          this.triggerClickHandlers.set(trigger, handler);
          trigger.addEventListener('click', handler);
        }
      }
    });
  }

  deactivateMobileCollapsibles() {
    const accordionElements = this.querySelectorAll('.footer-accordion');
    
    accordionElements.forEach((element) => {
      if (element.hasAttribute('data-collapsible-active')) {
        element.removeAttribute('data-collapsible-active');
        element.classList.remove('is-open');
        
        const trigger = element.querySelector(this.accordionTrigger);
        if (trigger && this.triggerClickHandlers.has(trigger)) {
          const handler = this.triggerClickHandlers.get(trigger);
          trigger.removeEventListener('click', handler);
          this.triggerClickHandlers.delete(trigger);
        }
      }
    });
  }
}
customElements.define('static-footer', Footer);
